import { useSearchParams } from "react-router-dom";
import { QuoteWizard } from "@/components/site/QuoteWizard";
import { BUSINESS } from "@/lib/site";
import { Clock, Lock, ShieldCheck } from "lucide-react";

const Quote = () => {
  const [params] = useSearchParams();
  const initialPlan = params.get("plan");

  return (
    <div data-testid="page-quote">
      <section className="bg-[var(--bg-secondary)] wave-divider">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-12">
          <p className="eyebrow">Free quote · 4 quick steps</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--ink)] tracking-tight leading-[1.05]">
            Let’s find your plan.
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-700 leading-relaxed">
            Answer four short questions and Christian will personally review your situation,
            compare every option in your county, and follow up with recommendations.
            Takes about three minutes.
          </p>
          <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-xs text-slate-600">
            <span className="flex items-center gap-2">
              <Lock className="w-4 h-4 text-[var(--brand-primary)]" /> Your info stays private
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[var(--brand-primary)]" /> No cost, no obligation
            </span>
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-[var(--brand-primary)]" /> Reply within 1 business day
            </span>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 sm:px-8 -mt-8 pb-24 relative">
        <QuoteWizard initialPlan={initialPlan} />
        <p className="mt-6 text-center text-xs text-slate-500">
          Prefer to talk? Call {BUSINESS.phone} (M–F · 9a–6p CT) — you’ll get Christian, not a call center.
        </p>
      </section>
    </div>
  );
};

export default Quote;
